import React, { useState } from 'react'
import { SupportedLocale, localeManager } from '../../utils/locale'
import styles from './LanguageSelector.module.css'

interface Language {
    code: SupportedLocale
    name: string
    flag: string
}

const languages: Language[] = [
    { code: 'en-US', name: 'English', flag: '🇺🇸' },
    { code: 'fr-FR', name: 'Français', flag: '🇫🇷' },
    { code: 'de-DE', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'es-ES', name: 'Español', flag: '🇪🇸' },
    { code: 'pt-PT', name: 'Português', flag: '🇵🇹' },
    { code: 'it-IT', name: 'Italiano', flag: '🇮🇹' },
    { code: 'ru-RU', name: 'Русский', flag: '🇷🇺' },
]

const LanguageSelector = () => {
    const [isOpen, setIsOpen] = useState(false)

    const currentLocate = localeManager.getCurrentLocale()
    const currentLang = languages.find(lang => lang.code === currentLocate) || languages[0]

    const handleLanguageSelect = async (locate: SupportedLocale) => {
        await localeManager.setLocale(locate)
        setIsOpen(false)
    }

    return (
        <div className={styles.languageSelector}>
            <button
                className={styles.currentLanguage}
                onClick={() => setIsOpen(!isOpen)}
                type="button"
            >
                <span className={styles.flag}>{currentLang.flag}</span>
                <span className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}>▼</span>
            </button>

            {isOpen && (
                <div className={styles.dropdown}>
                    {languages.map((language) => (
                        <button
                            key={language.code}
                            className={`${styles.languageOption} ${
                                language.code === currentLocate ? styles.active : ''
                            }`}
                            onClick={() => handleLanguageSelect(language.code)}
                            type="button"
                        >
                            <span className={styles.flag}>{language.flag}</span>
                            <span className={styles.languageName}>{language.name}</span>
                        </button>
                    ))}
                </div>
            )}

            {isOpen && (
                <div
                    className={styles.backdrop}
                    onClick={() => setIsOpen(false)}
                />
            )}
        </div>
    )
}

export default LanguageSelector
